import { store } from '../redux/storeConfig/store';
import { applicationActions } from '../new.redux/actions';

const PlanPermissionCheck = (targetPermission, intl, needsAlert = false) => {
    const state = store.getState();
    const copaniePlanPermissions = state?.companies?.currentCompany?.iuliPlan?.permissions
    const isIuliAdmin = state.auth?.login?.values?.loggedInUser?.is_iuli_admin;

    if (isIuliAdmin) 
        return true;

   let hasPermission = copaniePlanPermissions?.length > 0 && copaniePlanPermissions.some((permission) => permission === targetPermission);
   if (!hasPermission && needsAlert) 
    store.dispatch(
        applicationActions.toggleDialog({
          type: 'warning',
          title: intl.formatMessage({ id: 'plan.permission.warning' }),
          message: intl.formatMessage({ id: 'plan.permission.message' }),
          hasTimeout: true,
        })
      );
    return hasPermission;
}


export default PlanPermissionCheck;